<template>
    <v-card
        :class="{ 'card': this.$vuetify.breakpoint.smAndUp }"
        flat
    >
        <v-card-text>
            <v-form
                ref="form"
                v-model="formValid"
            >
                <v-alert
                    v-model="changePasswordSuccess"
                    dense
                    dismissible
                    text
                    type="success"
                    icon="check_circle_outlined"
                    close-icon="close"
                >
                    Password changed successfully!
                </v-alert>
                <v-alert
                    v-model="currentPasswordFailure"
                    dense
                    dismissible
                    text
                    type="error"
                    icon="info_outline"
                    class="errorAlert"
                    close-icon="close"
                >
                    Invalid current password specified!
                </v-alert>

                <v-text-field
                    class="mt-4"
                    outlined
                    label="Account"
                    :value="user.account"
                    disabled
                />
                <v-text-field
                    v-model="currentPassword"
                    outlined
                    label="Current Password"
                    :rules="ruleTests"
                    required
                    :type="showCurrentPassword ? 'text' : 'password' "
                >
                    <template v-slot:append>
                        <v-icon
                            class="material-icons-outlined"
                            @click="showCurrentPassword = !showCurrentPassword"
                        >
                            {{ getPasswordCurrentVisibilityIcon }}
                        </v-icon>
                    </template>
                </v-text-field>
                <v-card
                    class="mx-auto"
                    flat
                >
                    <v-card-text class="rule-list">
                        <div class="instructions">
                            Password must have the following:
                        </div>
                        <ul>
                            <li
                                v-for="rule of rules"
                                :key="rule.description"
                                class="rule-description"
                                :class="[ !passwordNew ? '' : rule.test(passwordNew) ? 'rule-passed' : 'rule-failed' ]"
                            >
                                {{ rule.description }}
                            </li>
                        </ul>
                    </v-card-text>
                </v-card>
                <v-text-field
                    v-model="passwordNew"
                    class="mt-8"
                    outlined
                    :type="showNewPassword ? 'text' : 'password' "
                    label="New Password"
                    prepend-inner-icon="lock_outline"
                    :error="missingPassword"
                    :rules="ruleTests"
                    required
                    @keyup="passwordInputKeyUp"
                >
                    <template v-slot:append>
                        <v-icon
                            class="material-icons-outlined"
                            @click="showNewPassword = !showNewPassword"
                        >
                            {{ getPasswordNewVisibilityIcon }}
                        </v-icon>
                    </template>
                </v-text-field>
                <v-text-field
                    v-model="passwordConfirm"
                    outlined
                    :type="showPasswordConfirm ? 'text' : 'password' "
                    label="Confirm Password"
                    prepend-inner-icon="lock_outline"
                    :error-messages="passwordConfirm.length && passwordNew !== passwordConfirm ? 'Password and confirm password must be match.' : ''"
                    required
                >
                    <template v-slot:append>
                        <v-icon
                            class="material-icons-outlined"
                            @click="showPasswordConfirm = !showPasswordConfirm"
                        >
                            {{ getPasswordConfirmVisibilityIcon }}
                        </v-icon>
                    </template>
                </v-text-field>
                <div
                    :class="{ 'bottomNav': !this.$vuetify.breakpoint.smAndUp }"
                >
                    <router-link
                        to="/"
                    >
                        <v-btn
                            :class="{ 'mobile-btn': !this.$vuetify.breakpoint.smAndUp }"
                            outlined
                            class="mr-4"
                        >
                            Cancel
                        </v-btn>
                    </router-link>
                    <v-btn
                        :class="{ 'mobile-btn': !this.$vuetify.breakpoint.smAndUp }"
                        :disabled="!formValid"
                        color="primary"
                        depressed
                        @click="changePassword"
                    >
                        Update
                    </v-btn>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
import { getStrengthRules } from '@/utils/password';
import webtmsBackend from '@/services/webtmsBackend';

export default {
    data: () => ({
        currentPassword: '',
        showCurrentPassword: false,
        showNewPassword: false,
        showPasswordConfirm: false,
        passwordNew: '',
        passwordConfirm: '',
        missingPassword: false,
        success: false,
        currentPasswordFailure: false,
        changePasswordFailure: false,
        changePasswordSuccess: false,
        formValid: false,
    }),
    computed: {
        user() {
            return this.$store.getters.user;
        },
        rules() {
            const option = this.$store.getters.companyOptions.find(companyOption => {
                return companyOption.option === 'USER_PASSWORD_STRENGTH';
            });
            if(option) {
                const passwordStrength = option.value;
                return getStrengthRules(passwordStrength.toUpperCase());
            }
            return [];
        },
        ruleTests() {
            let ruleTestArray = [];
            this.rules.forEach(rule => {
                ruleTestArray.push(rule.test);
            });
            return ruleTestArray;
        },
        getPasswordCurrentVisibilityIcon(){
            return this.showCurrentPassword ? 'visibility': 'visibility_off';
        },
        getPasswordNewVisibilityIcon(){
            return this.showNewPassword ? 'visibility': 'visibility_off';
        },
        getPasswordConfirmVisibilityIcon(){
            return this.showPasswordConfirm ? 'visibility': 'visibility_off';
        },
    },
    methods: {
        changePassword: async function () {
            if (!this.passwordNew) {
                this.missingPassword = true;
            } else {
                this.currentPasswordFailure = false;
                this.changePasswordFailure = false;
                this.changePasswordSuccess = false;
                try {
                    // call the password change service with token and new password
                    const result = await webtmsBackend.changeUserPassword({
                        uid: this.user.uid,
                        cid: this.user.cid,
                        account: this.user.account,
                        currentPassword: this.currentPassword,
                        newPassword: this.passwordNew,
                        newPasswordConfirm: this.passwordConfirm,
                    });
                    if (result.err === 'Invalid current password specified!') {
                        this.currentPasswordFailure = true;
                    } else if (result.err){
                        console.error('changePassword failed with ', result.err);
                        this.changePasswordFailure = true;
                    } else {
                        this.changePasswordSuccess = true;
                    }
                } catch (error) {
                    console.error(error);
                    this.changePasswordFailure = true;
                }
            }
        },
        passwordInputKeyUp: function () {
            if (this.passwordNew) {
                this.missingPassword = false;
            }
        },
    }
};
</script>
<style scoped>
.theme--light.v-tabs > .v-tabs-bar a{
    background-color: #F5F7FA;
    margin: 2px;
}
.rule-list {
    background: #F5F7FA;
    border-radius: 4px;
    color: #35383F;
    font-style: normal;
}
.instructions {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.0025em;
}
.rule-description {
    font-weight: normal;
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0.004em;
}
.rule-passed {
    color: #2FA84F;
}
.rule-failed {
    color: #CB3D31;
}
.errorAlert {
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.004em;
    color: #CB3D31;
}
a {
    text-decoration: none;
}
.card{
    width: 400px;
}

.bottomNav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 80px;
  display: flex;
  background: #ffffff;
  justify-content: center;
  padding: 16px 16px;
  border-top: 1px solid #dad6d6;

}
.v-btn.mobile-btn{
  width: 134px;
  height: 48px;
  padding: 16px;
}
</style>
